import { RouterGuard } from '../../services/router/types';

/**
 * Handle error routes.
 */
export const errorGuard: RouterGuard = function errorGuard(to, from, next) {
  if (to.name === 'error') {
    next(true);
  }
  // Allowed navigation: strip off any lingering error code by navigating to route without the error code.
  else if (to?.query?.code !== undefined) {
    delete to.query.code;
    next(to);
  }
  else {
    next();
  }
};
